import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { Star, HandHeart } from '@phosphor-icons/react';

import { bubbleImageSrc } from '@/lib/bubbleImage';
const Celebrities = () => {
  const [list, setList] = useState([]);
  useEffect(() => { api.get('/celebrities').then(({ data }) => setList(data.celebrities)); }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 py-10 pb-24">
      <div className="text-center mb-10">
        <Star size={36} weight="duotone" className="text-bx-gold mx-auto" />
        <h1 className="font-display text-4xl sm:text-6xl font-black tracking-tighter mt-2">
          Celebrities on <span className="shimmer-text">BubbleX</span>
        </h1>
        <p className="text-white/65 mt-2 max-w-2xl mx-auto">
          Every drop here is a one-of-one AI-stylized bubble signed by the artist. A share of every sale routes to a cause they picked.
        </p>
        <div className="mt-6 chip border-bx-gold/40 text-bx-gold mx-auto">
          <HandHeart size={12} weight="fill" /> ${list.reduce((s, c) => s + c.total_raised_for_causes, 0).toFixed(2)} raised for causes through celebrity drops
        </div>
      </div>

      {list.length === 0 ? (
        <div className="glass rounded-2xl p-10 text-center text-white/65">
          <p className="text-sm">No celebrities yet. <Link to="/contact" className="text-bx-cyan font-bold">Reach out</Link> to join the inaugural cohort.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {list.map((c) => (
            <div key={c.celebrity_name} className="glass rounded-2xl p-6" data-testid={`celeb-${c.celebrity_name}`}>
              <div className="flex items-center gap-4">
                {bubbleImageSrc(c) ? (
                  <img src={bubbleImageSrc(c)} alt={c.celebrity_name} className="h-16 w-16 rounded-full object-cover ring-1 ring-bx-gold/40" />
                ) : (
                  <div className="h-16 w-16 rounded-full bg-gradient-to-br from-bx-gold to-bx-legendary" />
                )}
                <div className="flex-1 min-w-0">
                  <h3 className="font-display text-xl font-bold truncate">{c.celebrity_name}</h3>
                  <div className="text-[10px] uppercase tracking-widest text-white/60">
                    {c.drops.length} drop{c.drops.length === 1 ? '' : 's'} · {c.total_sold}/{c.total_supply} sold
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-2 mt-4">
                <div className="glass-hi rounded-lg p-3">
                  <div className="font-display text-xl font-black text-bx-magenta">${c.total_raised_for_causes.toFixed(2)}</div>
                  <div className="text-[10px] uppercase tracking-widest text-white/60">to causes</div>
                </div>
                <div className="glass-hi rounded-lg p-3">
                  <div className="font-display text-xl font-black text-bx-volt">${c.earned.toFixed(2)}</div>
                  <div className="text-[10px] uppercase tracking-widest text-white/60">artist owed</div>
                </div>
              </div>
              <Link to="/drops" className="btn-primary block text-center mt-4 px-4 py-2.5 rounded-full text-sm" data-testid={`celeb-shop-${c.celebrity_name}`}>
                Explore drops →
              </Link>
            </div>
          ))}
        </div>
      )}

      <div className="mt-16 grad-border p-6 sm:p-10 text-center">
        <h2 className="font-display text-2xl sm:text-4xl font-black tracking-tighter">
          Want your face on a BubbleX drop?
        </h2>
        <p className="text-white/65 mt-2 max-w-xl mx-auto text-sm">
          Press, managers, and creators — pitch a Drop, pick a cause, keep 50% of revenue. AI handles the artwork. We handle the network.
        </p>
        <Link to="/contact" data-testid="celeb-pitch" className="btn-primary px-6 py-3 rounded-full text-sm inline-flex items-center gap-2 mt-5">
          Pitch a drop
        </Link>
      </div>
    </div>
  );
};

export default Celebrities;
